<template>
  <div class="page">
    <api-header :user-info="userInfo"></api-header>
    <div class="main" :style="{'height': pageHeight + 'px'}">
      <p class="title">{{pageName}}</p>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  import ApiHeader from './components/api-header.vue';
  export default {
    data () {
      return {
        pageHeight: window.innerHeight - 72,
        userInfo: null
      }
    },
    computed: {
      pageName() {
        return {
          document: '开放文档',
          account: '账户对接'
        }[this.$route.name];
      }
    },
    components: {
      ApiHeader
    },
    mounted() {
      this.userInfo = window.GLOBAL ? window.GLOBAL.userInfo : null;
    }
  }
</script>